var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var ReUpPhoneNumberInput = require('./ReUpPhoneNumberInput');
var PlatformConstants = require('./constants/PlatformConstants');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
  Platform
} = ReactNative;

var NumericalInput = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      style : {},
      previewStyle : {},
      valueChanged : function(newValue, newStringValue){},
      isDollars : false,
      isCheckin : false,
      appManager : null,
      dollarsPerPoint : 1,
      displayPoints : false,
      isPhoneNumber : false,
      isDisplayingPin :false,
      checkPinError : function(){return false},
      checkPinSuccess : function(){return false},
      maxLength : 4,
      initialValue : "",
      inputTextColor : null,
      isInError: false,
      phoneLocales:null,

    }
  },

  getInitialState : function()
  {
    return {
      value:this.props.isPhoneNumber ? this.props.initialValue : (this.props.isDisplayingPin ? "" : 0),
      predictedValue:"",
    }
  },

  componentDidMount : function()
  {

  },

  didUpdate : function(data)
  {

  },

    setPhoneLocales : function(phoneLocales)
  {
   // if( JSON.stringify(phoneLocales) != JSON.stringify(this.state.phoneLocales) ) this.setState({phoneLocales});
  },

  doTransaction: function()
  {
    this.props.appActions.requestFeatureName("TransactionResult");
  },

  numSelected: function(i)
  {
    var thisThing = this;
    if( this.props.isDisplayingPin )
    {
      var newValue = this.state.value + "" + i;
      var isSuccess = this.props.checkPinSuccess(newValue);
      if( newValue.length <= this.props.maxLength )
      {
        this.valueChanged(newValue);
        this.setState({value:newValue});
        if( isSuccess )
        {
          setTimeout(function()
          {
            thisThing.props.didSucceed()
          }, 500)
        }
      }
    }
    else if( this.props.isPhoneNumber )
    {
      var newValue = this.strippedPhoneNumber(this.state.value) + "" + i;
      var stringPhoneValue = this.stringPhoneValue(newValue);
      // this.valueChanged(stringPhoneValue);
      this._phoneInput.setPhoneNumber(stringPhoneValue);
      this.setState({value:stringPhoneValue});
    }
    else
    {
      var newValue = this.state.value * 10 + i;
      if( this.props.displayPoints && this.stringPointValue(newValue).length > 10 ) return;
      if( this.stringDollarValue(newValue).length > 11 ) return; // some sort of max
      this.valueChanged(newValue);

      this.setState({value:newValue});
    }
  },

  deleteSelected: function()
  {
    if( this.props.isDisplayingPin )
    {
      if( this.state.value.length <= 0 ) return;

      var newValue = this.state.value.substring(0, this.state.value.length-1);
      this.valueChanged(newValue);
      this.setState({value:newValue});
    }
    else if( this.props.isPhoneNumber )
    {
      if( this.state.value.length <= 0 ) return;
      
      var newValue = this.strippedPhoneNumber(this.state.value);
      if( newValue.length > 0 ) newValue = newValue.substring(0, newValue.length-1);
      newValue = this.stringPhoneValue(newValue);
      this._phoneInput.setPhoneNumber(newValue);
      this.valueChanged(newValue);
      this.setState({value:newValue});
    }
    else
    {
      var newValue = Math.floor(this.state.value / 10);
      this.valueChanged(newValue);
      this.setState({value:newValue});
    }
  },

  stringDollarValue: function(value)
  {
    if( typeof value === 'undefined' ) value = this.state.value;

    return this.props.appManager.getLocalizationManager().localizedDollars(parseFloat(value)/100);
  },

  stringPointValue: function(value)
  {
    value = this.pointsAmount(value);

    var points = this.props.appManager.getLocalizationManager().localizedPoints(value);
    if( points.length > 10 )
    {
      points = this.props.appManager.getLocalizationManager().localizedPts(value);
    }

    return points;
  },

  stringPhoneValue: function(value)
  {
    // Kelsey, TODO: need to add formatting back at some point
    return value;

    if( typeof value === 'undefined' ) value = this.state.value;

    var strippedValue = this.strippedPhoneNumber(value);
    while( strippedValue.length < 11 ) strippedValue += ' ';

    return strippedValue.substring(0,1)
      + "(" + strippedValue.substring(1,4) + ")"
      + strippedValue.substring(4,7) + "-"
      + strippedValue.substring(7,11);
  },

  strippedPhoneNumber: function(phoneNumber)
  {
    if( typeof phoneNumber === 'undefined' ) phoneNumber = this.state.value;

    return phoneNumber.replace("-","").replace("(","").replace(")","").replace(/ /g,"")
  },

  stringPinValue: function(value)
  {
    var starredOutput = "";
    if( typeof value === 'undefined' ) value = this.state.value;

    for( var i = 0; i < value.length; i++ ) starredOutput += "*";

    return starredOutput;
  },

  stringValue: function(value)
  {
    if( this.props.isDollars )
    {
      return this.stringDollarValue(value);
    }
    else if( this.props.isPhoneNumber )
    {
      return this.stringPointValue(value);
    }
    else
    {
      return this.stringPointValue(value);
    }
  },

  clearSelected: function()
  {
    if( this.props.isDisplayingPin )
    {
      if( this.state.value.length <= 0 ) return;

      var newValue = "";
      this.valueChanged(newValue);
      this.setState({value:newValue});
    }
    else if( this.props.isPhoneNumber )
    {
      var newValue = this.stringPhoneValue(this.props.initialValue);
      this._phoneInput.setPhoneNumber(newValue);
      // this.valueChanged(this._phoneInput.getCountryCode() + newValue);

      this.setState({value:newValue});
    }
    else
    {
      var newValue = 0;
      this.valueChanged(newValue);

      this.setState({value:newValue});
    }
  },

  valueChanged: function(newValue)
  {
    if( this.props.isDollars )
    {
      this.props.valueChanged(newValue, this.stringValue(newValue));
    }
    else if( this.props.isCheckin )
    {
      this.props.valueChanged(newValue, this.stringPointValue(newValue));
    }
    else
    {
      this.props.valueChanged(newValue);
    }
  },

  pointsAmount: function(value)
  {
    if( typeof value === 'undefined' ) value = this.state.value;
    if( this.props.displayPoints ) return Math.floor(value);

    return Math.floor(value/(100 * this.props.dollarsPerPoint) )
  },

  dollarsAmount: function(value)
  {
    if( typeof value === 'undefined' ) value = this.state.value;

    return parseFloat(value)/100;
  },

  phoneNumber: function(value)
  {

  },

  setPredictedValue: function(predictedValue)
  {
    this.setState({predictedValue})
  },

  phoneNumberChanged: function(countryCode, phoneNumber)
  {
    this.props.valueChanged(phoneNumber);
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;

    var locManager = appManager.getLocalizationManager();
    var rowStyle = {flexDirection:'row',flex:1};
    var numSelected = thisThing.numSelected;
    var clearSelected = thisThing.clearSelected;
    var deleteSelected = thisThing.deleteSelected;
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var generalTitleColorAlphaed = appManager.getColorForKey("GeneralTitleColor", .6);
    var buttonStyle = {flex:1, margin:4, height:-1};
    var inputTextColor = this.props.inputTextColor == null ? appManager.getColorForKey("GeneralTitleColor") : this.props.inputTextColor;

    var isInError = false;
    if( this.props.isDisplayingPin ) isInError = this.props.checkPinError(this.state.value);
    var monospaceFontFamily = 'CourierNewPS-BoldMT';
    if( Platform.OS != 'ios' ) monospaceFontFamily = 'monospace';

    return (
      <View style={[this.props.style, {flexDirection:'column', marginTop:6, marginBottom:6}]}>
        {
          this.props.isDisplayingPin ?
            <View style={rowStyle} >
              <ReUpButton useShadow={false} fontSize={24} onPress={() => {deleteSelected()}} appManager={appManager} isSecondary={true} text={locManager.localizedStringForKey("NUMERICAL_INPUT_DELETE")} style={buttonStyle} />
              <View style={{flexDirection:'column', flex:2,fontSize:28,margin:4,padding:10,justifyContent:'center', alignItems:'flex-end', borderWidth:2,borderStyle:'solid',borderRadius:4, borderColor:generalTitleColorAlphaed, backgroundColor:isInError ? 'red' : 'transparent'}}>
                <Text style={{fontSize:28, fontFamily:monospaceFontFamily, color:inputTextColor}}>{ this.stringPinValue() }</Text>
              </View>
            </View>
          :
            <View style={rowStyle} >
            {
              this.props.isPhoneNumber ?
              <View style={[{flexDirection:'column', flex:5,justifyContent:'center', alignItems: 'center'}, this.props.previewStyle]}>
                <ReUpPhoneNumberInput ref={(a)=>this._phoneInput=a} appManager={appManager}
                                      isInError={this.props.isInError}
                  phoneLocales={this.props.phoneLocales} style={{alignSelf:'stretch'}}
                  phoneNumberChanged={(countryCode, newPhoneNumber)=>{thisThing.phoneNumberChanged(countryCode, newPhoneNumber)}} />
              </View>
              :
              <View style={[{flexDirection:'column', flex:2,margin:4,padding:10,justifyContent:'center', alignItems:this.props.isPhoneNumber ? 'center' : 'flex-end', borderWidth:2,borderStyle:'solid',borderRadius:4, borderColor:generalTitleColorAlphaed}, this.props.previewStyle]}>
                <View style={{position:'absolute', opacity:.4, top:0, left:0, bottom:0, right:0, justifyContent:'center', alignItems:'center'}}>
                  <Text style={{fontSize:24, fontFamily:monospaceFontFamily, color:inputTextColor}}>{ this.state.predictedValue }</Text>
                </View>
                <View style={{backgroundColor:'transparent', position:'absolute', top:0, left:0, bottom:0, right:0, justifyContent:'center', alignItems:'center'}}>
                  <Text style={{backgroundColor:'transparent', fontSize:24, fontFamily:monospaceFontFamily, color:inputTextColor}}>{ this.props.isPhoneNumber ? this.stringPhoneValue() : (this.props.displayPoints ? this.stringPointValue() : this.stringDollarValue())}</Text>
                </View>
              </View>
            }
            </View>
        }


      </View>
    );
  }
});

var styles = StyleSheet.create({
});


NumericalInput.dataDependencies = ["PhoneLocales"]

module.exports = NumericalInput;



// WEBPACK FOOTER //
// ./src/NumericalInput.js